import OrderLogApi from '@apis/order/OrderLogApi';
import orderLogQueries from '@apis/queries/orderLogQueries';
import { GetOrderLogsParams } from '@models/order/orderLog';
import { useInfiniteQuery } from '@tanstack/react-query';
import { getFlattenPageResponse, getIsBlank, getNextPageParam } from '@utils/slice';
import dayjs from 'dayjs';

const DATE_FORMAT = 'YYYY-MM-DD';

function useOrderLogs(duration: 'WEEK'| 'ONE_MONTH' | 'THREE_MONTH' | 'ALL') {
    const to = dayjs().format(DATE_FORMAT);
    const from = (() => {
        switch (duration) {
        case 'WEEK':
            return dayjs().subtract(1, 'week').format(DATE_FORMAT);
        case 'ONE_MONTH':
            return dayjs().subtract(1, 'month').format(DATE_FORMAT);
        case 'THREE_MONTH':
            return dayjs().subtract(3, 'month').format(DATE_FORMAT);
        default:
            return dayjs().subtract(6, 'month').format(DATE_FORMAT);
        }
    })();
    const params: Omit<GetOrderLogsParams, 'page'> = {
        size: 5,
        from,
        to,
    };
    const queryInfo = useInfiniteQuery({
        queryKey: orderLogQueries.list(params).queryKey,
        queryFn: ({ pageParam }) => OrderLogApi.getOrderLogs({ ...params, page: pageParam }),
        initialPageParam: 0,
        getNextPageParam,
    });
    const orderLogs = getFlattenPageResponse(queryInfo);
    const isEmpty = getIsBlank(queryInfo);
    return {
        ...queryInfo,
        orderLogs,
        isEmpty,
    };
}

export default useOrderLogs;
